<script lang="ts">
  import Flash from "@shared/services/flashv2.js";
  import Large from "@shared/svelte/Components/Pagination/Large.svelte";
  import type { PaginationDetails } from "@shared/types/Pagination";
  import * as _ from "lodash";
  import Authorization from "@shared/svelte/Components/Authorization.svelte";

  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import EmployeeCard from "./EmployeeCard.svelte";
  import CreateEmployeeModal from "./CreateEmployeeModal.svelte";

  import { HttpPromiseWithEntireResponse } from "@shared/svelte/Modules/ApiService";

  import { onMount } from "svelte";

  let employees = [];
  let showModal = false;
  let managedValue = false;
  let searchValue = "";

  let userDistributors = _.get(window, "$rootScope.user.distributors");
  let currentUserRole = ((userDistributors || [])[0] || {}).role;
  let page = 1;
  let pagination: PaginationDetails = {
    page,
    perPage: 20,
    goToPage: number => {
      page = number;
      pagination.page = page;
      fetchEmployees();
    },
    totalEntries: 0,
    showTotals: false,
  };

  const fetchEmployees = async function () {
    try {
      const res = await HttpPromiseWithEntireResponse({
        method: "GET",
        url: "/api/distributor/sales_reps",
        data: {
          retailer_count: true,
          page: pagination.page,
          managed: managedValue,
          search: searchValue,
        },
      });
      employees = await res.json();
      pagination.totalEntries = parseInt(res.headers.get("X-Pagination-Entries"));
      pagination.perPage = parseInt(res.headers.get("X-Pagination-Limit"));
    } catch (_) {
      Flash.now({ type: "error", message: "There was an error fetching employees." });
    }
  };
  onMount(() => fetchEmployees());
  const debouncedFetchEmployees = _.debounce(fetchEmployees, 250);
  const openCreateEmployeeModal = () => {
    showModal = true;
  };
</script>

<FizzStyles>
  <div class="fizz-stack-8 fizz-surface fizz-flex-row fizz-inset-square-16 fizz-space-between">
    <h3 class="fizz-heading-3">Employees</h3>
    <Authorization authName="sales_reps.create">
      <button
        class="fizz-button-secondary"
        data-testid="new-target-button"
        on:click={() => {
          openCreateEmployeeModal();
        }}>Add Employee</button
      >
    </Authorization>
  </div>

  <div class="fizz-inset-horizontal-32 fizz-container-medium">
    <div class="fizz-inset-square-8 fizz-surface fizz-full-width fizz-flex-row">
      <input
        type="text"
        name="search"
        data-testid="distributor-employees-search-input"
        id="distributor-employees-search-input"
        placeholder="Search Employees"
        class="fizz-input-search fizz-full-width"
        bind:value={searchValue}
        on:keyup={debouncedFetchEmployees}
      />
    </div>

    {#if currentUserRole == "manager"}
      <div class="fizz-inset-square-8 fizz-surface fizz-flex-row fizz-half-width fizz-margin-auto">
        <select
          bind:value={managedValue}
          class="fizz-select fizz-full-width"
          name="managed"
          id="managed-select"
          data-testid="managed-select"
          on:change={debouncedFetchEmployees}
        >
          <option value={false}>All Reps</option>
          <option value={true}>Managed by Me</option>
        </select>
      </div>
    {/if}

    <div
      class="fizz-inset-vertical-8 fizz-justify-center"
      id="sales-reps-index"
      data-testid="sales-reps-index"
    >
      {#each employees as employee}
        <div class="fizz-inset-vertical-8">
          <EmployeeCard {employee} />
        </div>
      {/each}
      {#if employees.length == 0}
        <div> No employees found for this search. </div>
      {/if}
      <Large {pagination} />
    </div>
  </div>

  <CreateEmployeeModal bind:show={showModal} />
</FizzStyles>
